
// src/pages/CheckEmail.jsx
import React, { useState } from "react";
import { Container, Alert, Button, Spinner } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { auth } from "../firebase";
import { sendEmailVerification } from "firebase/auth";

export default function CheckEmail() {
  const [params] = useSearchParams();
  const communityId = params.get("community") || "";
  const email = params.get("email") || "";
  const navigate = useNavigate();

  const [status, setStatus] = useState({ loading: false, message: "" });

  const handleResend = async () => {
    const user = auth.currentUser;
    if (!user) {
      setStatus({ loading: false, message: "Please sign in first to resend verification." });
      return;
    }
    setStatus({ loading: true, message: "" });
    try {
      await sendEmailVerification(user, {
        url: `${window.location.origin}/verify-success?community=${communityId}`,
        handleCodeInApp: false,
      });
      setStatus({ loading: false, message: "Verification email resent. Check your inbox and spam folder." });
    } catch (e) {
      console.error("Resend failed:", e);
      setStatus({ loading: false, message: e?.message || "Could not resend verification email." });
    }
  };

  return (
    <Container className="py-4">
      <Alert variant="info" className="mb-3">
        <h4 className="mb-2">Check your inbox</h4>
        <p>
          We sent a verification link to <strong>{email || "your email"}</strong>. Please verify your email
          within 1 hour. If the link has expired, click <em>Resend verification</em>.
        </p>
        <ul className="mb-0">
          <li>Check Spam/Junk/Promotions tab.</li>
          <li>Keep this tab open; once verified you can continue.</li>
        </ul>
      </Alert>

      <div className="d-flex gap-2">
        <Button onClick={handleResend} disabled={status.loading}>
          {status.loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" /> Resending…
            </>
          ) : (
            "Resend verification email"
          )}
        </Button>

        {communityId ? (
          <Button variant="outline-secondary" onClick={() => navigate(`/resident/${communityId}`)}>
            Go to community
          </Button>
        ) : (
          <Button variant="outline-secondary" onClick={() => navigate("/")}>
            Go to home
          </Button>
        )}
      </div>

      {status.message && <p className="text-muted mt-3 mb-0">{status.message}</p>}
    </Container>
  );
}
